import React, { useState } from "react";
import { getCurrentYear, getYears } from "../../utils/content";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setOptionsAction } from "../../store/reducers/commonSlice";

export const months = [
  "All months",
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const periodOptions: { [key: string]: string } = {
  lastMonth: "Last month",
  last90Days: "Last 90 days",
  lastYear: "Last 12 months",
  year: "Choose year",
};

const currentYear = getCurrentYear();

const ViewsFilter = () => {
  const dispatch = useAppDispatch();
  const options = useAppSelector((state) => state.common.options);

  const changeFilterType = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const type = e.target.value;
    if (!type) return;

    dispatch(
      setOptionsAction({
        revisionsFilterPeriod: type,
        revisionsFilterValue: type === "year" ? currentYear : 0,
        revisionsFilterMonthValue:
          type === "lastYear" ? 0 : options.revisionsFilterMonthValue,
      })
    );
  };

  const changeFilterValue = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    if (!value) return;
    if (options.revisionsFilterPeriod !== "year") return;

    dispatch(
      setOptionsAction({
        revisionsFilterValue: +value,
      })
    );
  };

  const changeFilterMonthValue = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    if (value === undefined) return;

    dispatch(
      setOptionsAction({
        revisionsFilterMonthValue: +value,
      })
    );
  };

  const enablePerMonths = () => {
    return options.revisionsFilterPeriod === "year";
  };

  return (
    <div className="text-lg w-full md:w-auto justify-center md:justify-start flex">
      <div className="flex items-center">
        <span className="mr-3">Filter: </span>
        {enablePerMonths() && (
          <select
            name="month"
            value={options.revisionsFilterMonthValue}
            className="mr-3 py-2 px-4"
            onChange={changeFilterMonthValue}
          >
            {months.map((month: string, index: number) => (
              <option key={index} value={index}>
                {month}
              </option>
            ))}
          </select>
        )}
        {options.revisionsFilterPeriod === "year" && (
          <select
            name="value"
            value={options.revisionsFilterValue ?? currentYear}
            className="mr-3 py-2 px-4"
            onChange={changeFilterValue}
          >
            {getYears(currentYear, 15).map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        )}
        <select
          name="type"
          className="mr-3 py-2 px-4"
          value={options.revisionsFilterPeriod}
          onChange={changeFilterType}
        >
          {Object.keys(periodOptions).map((type: string) => (
            <option key={type} value={type}>
              {periodOptions[type]}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ViewsFilter;
